// extracted by mini-css-extract-plugin
export default {"wrapper":"NoToolsLayout_wrapper__9rShw"};